import { render } from "./BorderFooterBottom.vue?vue&type=template&id=0319affc"
import script from "./BorderFooterBottom.vue?vue&type=script&lang=js"
export * from "./BorderFooterBottom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__